import {
    FETCH_CLIENT_ENERGY_EQUIPMENT,
    FETCH_CLIENT_ENERGY_KPI,
    FETCH_EQUIPMENT_AVOIDED_COSTS,
    FETCH_ENERGY_EQUIPMENT,
    FETCH_ENERGY_SITES,
    FETCH_EQUIPMENT_ENERGY_DATA,
    FETCH_ENERGY_EQUIPMENT_SUMMARY,
    FETCH_ENERGY_EQUIPMENT_GROUP,
    FETCH_EQUIPMENT_ENERGY_KPI,
    FETCH_EQUIPMENT_FUTURE_SAVINGS,
    FETCH_SITE_AVOIDED_COSTS,
    FETCH_SITE_ENERGY_DATA,
    FETCH_SITE_ENERGY_KPI,
    FETCH_SITE_FUTURE_SAVINGS
} from '../actions/actionTypes';

const initialState = {
    clientEnergyEquipment:  [],
    clientEnergyKpis:       {},
    clientEnergySites:      [],
    equipmentAvoidedCosts:  [],
    equipmentEnergyData:    {},
    equipmentEnergyKpis:    {},
    equipmentFutureSavings: [],
    siteAvoidedCosts:       [],
    siteEnergyData:         {},
    siteEnergyEquipment:    [],
    siteEnergyKpis:         {},
    siteFutureSavings:      []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CLIENT_ENERGY_KPI:
            return {
                ...state,
                clientEnergyKpis: {...action.payload}
            };
        case FETCH_EQUIPMENT_AVOIDED_COSTS:
            return {
                ...state,
                equipmentAvoidedCosts: [...action.payload]
            };
        case FETCH_EQUIPMENT_FUTURE_SAVINGS:
            return {
                ...state,
                equipmentFutureSavings: [...action.payload]
            };
        case FETCH_ENERGY_EQUIPMENT:
            return {
                ...state,
                siteEnergyEquipment: [...action.payload]
            };

        case FETCH_ENERGY_EQUIPMENT_SUMMARY:
            return {
                ...state,
                siteEnergyEquipmentSummary: [...action.payload]
            };

        case FETCH_ENERGY_EQUIPMENT_GROUP:
            return {
                ...state,
                siteEnergyEquipmentGroup: [...action.payload]
            };
            
        case FETCH_CLIENT_ENERGY_EQUIPMENT:
            return {
                ...state,
                clientEnergyEquipment: [...action.payload]
            };
        case FETCH_ENERGY_SITES:
            return {
                ...state,
                clientEnergySites: [...action.payload]
            };
        case FETCH_EQUIPMENT_ENERGY_DATA:
            return {
                ...state,
                equipmentEnergyData: {...action.payload }
            };
        case FETCH_EQUIPMENT_ENERGY_KPI:
            return {
                ...state,
                equipmentEnergyKpis: { ...action.payload}
            };
        case FETCH_SITE_AVOIDED_COSTS:
            return {
                ...state,
                siteAvoidedCosts: [...action.payload]
            };
        case FETCH_SITE_ENERGY_DATA:
            return {
                ...state,
                siteEnergyData: { ...action.payload }
            };
        case FETCH_SITE_ENERGY_KPI:
            return {
                ...state,
                siteEnergyKpis: { ...action.payload }
            };
        case FETCH_SITE_FUTURE_SAVINGS:
            return {
                ...state,
                siteFutureSavings: [...action.payload]
            };
        default:
            return state;
    }
};
